import { Flex, HStack, IconButton, Stack, Text } from '@chakra-ui/react';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CombinedCartData } from '../shoppingCart/hooks/useShoppingCartData.tsx';
import { formatPrice } from '../../../components/common/PriceTag.tsx';

export type CartSidebarItemProps = {
  model: CombinedCartData;
  onRemove: () => void;
};

export const CartSidebarItem = (props: CartSidebarItemProps) => {
  const { model, onRemove } = props;

  // Price is already the full per-line total (quantity included), so do not multiply again.
  const lineTotal = model.Price;
  const details = [model.Form, model.Strength ? `${model.Strength}${model.StrengthUnit}` : null]
    .filter(Boolean)
    .join(' • ');

  return (
    <Flex gap='2' py='2' borderBottomWidth='1px' borderColor='gray.100' _last={{ borderBottomWidth: 0 }}>
      <Stack gap='0.5' flex='1' minW='0'>
        <HStack justify='space-between' align='flex-start'>
          <Text fontWeight='medium' fontSize='sm' lineClamp={1}>
            {model.IsCustom && 'Custom: '}
            {model.DrugName}
          </Text>
          <IconButton
            aria-label='Remove item'
            size='2xs'
            variant='ghost'
            colorPalette='gray'
            onClick={onRemove}
            rounded='full'>
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </HStack>
        <Text fontSize='xs' color='gray.500' lineClamp={1}>
          {details}
        </Text>
        <HStack justify='space-between' fontSize='sm'>
          <Text color='gray.600'>Qty: {model.Quantity}</Text>
          {lineTotal ? (
            <Text fontWeight='semibold'>{formatPrice(lineTotal)}</Text>
          ) : (
            <Text fontSize='xs' color='gray.400'>
              Quote
            </Text>
          )}
        </HStack>
      </Stack>
    </Flex>
  );
};
